import { render, staticRenderFns } from "./signupAfter.vue?vue&type=template&id=c7210e0e&scoped=true&"
import script from "./signupAfter.vue?vue&type=script&lang=js&"
export * from "./signupAfter.vue?vue&type=script&lang=js&"
import style0 from "./signupAfter.vue?vue&type=style&index=0&id=c7210e0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7210e0e",
  null
  
)

export default component.exports